import React from "react";

/**
 * C-ORE module icon set — single-stroke, 24x24 viewBox, colour inherited
 * from the row via `currentColor` (same contract the lucide icons had).
 * Source: C-ORE-Module-Icons.html (design handoff).
 */
function icon(paths) {
  return function CoreGlyph({ size = 20, className, ...rest }) {
    return (
      <svg
        viewBox="0 0 24 24"
        width={size}
        height={size}
        fill="none"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        className={className}
        {...rest}
      >
        {paths}
      </svg>
    );
  };
}

export const IconBoardroom = icon(
  <>
    <rect x="3.2" y="4" width="7.6" height="16" rx="1.8" />
    <rect x="13.2" y="4" width="7.6" height="6.6" rx="1.8" />
    <rect x="13.2" y="13.4" width="7.6" height="6.6" rx="1.8" />
  </>
);

export const IconCommandCenter = icon(
  <>
    <rect x="3" y="4.5" width="18" height="12.5" rx="2" />
    <path d="M6.5 11.5 L9 11.5 L10.5 8.5 L13 14 L14.5 11.5 L17.5 11.5" />
    <path d="M12 17v3" />
    <path d="M8.5 20h7" />
  </>
);

export const IconCeo = icon(
  <>
    <circle cx="12" cy="12" r="8.4" />
    <path d="M16.1 7.9 13.4 13.4 7.9 16.1 10.6 10.6Z" />
    <circle cx="12" cy="12" r="1" fill="currentColor" stroke="none" />
  </>
);

export const IconCfo = icon(
  <>
    <ellipse cx="12" cy="6.6" rx="6.8" ry="2.6" />
    <ellipse cx="12" cy="12" rx="6.8" ry="2.6" />
    <ellipse cx="12" cy="17.4" rx="6.8" ry="2.6" />
  </>
);

export const IconCmo = icon(<path d="M3.8 5h16.4l-6.2 7.2v7.3l-4-2.1v-5.2z" />);

export const IconCto = icon(
  <>
    <rect x="3.5" y="3.4" width="17" height="5.1" rx="1.8" />
    <rect x="3.5" y="15.5" width="17" height="5.1" rx="1.8" />
    <rect x="3.5" y="9.45" width="17" height="5.1" rx="1.8" />
    <circle cx="7" cy="5.95" r="1.05" fill="currentColor" stroke="none" />
    <circle cx="7" cy="12" r="1.05" fill="currentColor" stroke="none" />
    <circle cx="7" cy="18.05" r="1.05" fill="currentColor" stroke="none" />
  </>
);

export const IconExecutiveBriefing = icon(
  <>
    <path d="M6 3h7.5L19 8.5V21H6z" />
    <path d="M13.5 3v5.5H19" />
    <path d="M9 13h7" />
    <path d="M9 17h4.5" />
  </>
);

export const IconFinancialTrends = icon(
  <>
    <path d="M4 4v16h16" />
    <path d="M7.5 16.2 11 11.4 14.5 14 18.8 7.6" />
    <circle cx="7.5" cy="16.2" r="1.3" fill="currentColor" stroke="none" />
    <circle cx="11" cy="11.4" r="1.3" fill="currentColor" stroke="none" />
    <circle cx="14.5" cy="14" r="1.3" fill="currentColor" stroke="none" />
    <circle cx="18.8" cy="7.6" r="1.3" fill="currentColor" stroke="none" />
  </>
);

export const IconFinancialSync = icon(
  <>
    <path d="M20 12a8 8 0 0 1-13.4 5.9" />
    <path d="M4 12a8 8 0 0 1 13.4-5.9" />
    <path d="M17.4 2.6v3.7h-3.7" />
    <path d="M6.6 21.4v-3.7h3.7" />
  </>
);

export const IconStatementHistory = icon(
  <>
    <path d="M18.2 10.1V4.6A1.6 1.6 0 0 0 16.6 3H5.6A1.6 1.6 0 0 0 4 4.6v14.8A1.6 1.6 0 0 0 5.6 21h3.9" />
    <path d="M7.4 7.4h7.4" />
    <path d="M7.4 11.4h4.4" />
    <circle cx="16.9" cy="16.9" r="4.6" />
    <path d="M16.9 14.6v2.3l1.6 1" />
  </>
);

export const IconCompanyTrajectory = icon(
  <>
    <path d="M3.5 19.5c4.6-.4 8-3.6 9.6-8" />
    <path d="M13.1 11.5c1.4-3.7 3.9-6 7.4-7" />
    <circle cx="3.5" cy="19.5" r="1.6" fill="currentColor" stroke="none" />
    <circle cx="20.5" cy="4.5" r="1.6" fill="currentColor" stroke="none" />
  </>
);

export const IconForecasting = icon(
  <>
    <path d="M3.5 18.6 11 11.9" />
    <path d="M11 11.9 20.4 5.2" strokeDasharray="3.2 2.8" />
    <path d="M17.3 4.9h3.4v3.4" />
    <circle cx="11" cy="11.9" r="1.7" fill="currentColor" stroke="none" />
  </>
);

export const IconSmartAlerts = icon(
  <>
    <path d="M17.2 15.4V10a5.3 5.3 0 0 0-10.6 0v5.4L4.8 18.3h14.4z" />
    <path d="M10 21h4" />
    <circle cx="18.3" cy="5.7" r="2" fill="currentColor" stroke="none" />
  </>
);

export const IconBusinessCockpit = icon(
  <>
    <path d="M3.5 18.2a8.5 8.5 0 0 1 17 0" />
    <path d="M12 18.2 17.4 11.6" />
    <circle cx="12" cy="18.2" r="1.8" fill="currentColor" stroke="none" />
  </>
);

export const IconBenchmarking = icon(
  <>
    <path d="M6 20.5v-4.6" />
    <path d="M12 20.5V11" />
    <path d="M18 20.5V5.8" />
    <path d="M3 20.5h18" />
    <path d="M3 13h18" strokeDasharray="3.2 2.8" />
  </>
);

export const IconSupplierAudit = icon(
  <>
    <path d="M20 13.2V5.5A1.5 1.5 0 0 0 18.5 4h-13A1.5 1.5 0 0 0 4 5.5v11A1.5 1.5 0 0 0 5.5 18h7" />
    <path d="M7.5 8.5h9" />
    <path d="M7.5 12.5h4.5" />
    <circle cx="17" cy="17.5" r="4.2" />
    <path d="M15.2 17.5 16.6 18.9 18.9 16.2" />
  </>
);

export const IconAdvancedTools = icon(
  <>
    <path d="M3.5 6.5h16" />
    <path d="M4.5 12h16" />
    <path d="M3.5 17.5h16" />
    <circle cx="9" cy="6.5" r="2.3" />
    <circle cx="15.5" cy="12" r="2.3" />
    <circle cx="7" cy="17.5" r="2.3" />
  </>
);

export const IconCoreConnect = icon(
  <>
    <circle cx="12" cy="5.2" r="2.6" />
    <circle cx="5.2" cy="17.6" r="2.6" />
    <circle cx="18.8" cy="17.6" r="2.6" />
    <path d="M10.7 7.5 6.5 15.3" />
    <path d="M13.3 7.5 17.5 15.3" />
    <path d="M7.8 17.6h8.4" />
  </>
);

export const IconCoreFund = icon(
  <>
    <rect x="3" y="3" width="18" height="18" rx="3.6" />
    <path d="M15.6 8.4h-5.4a1.8 1.8 0 1 0 0 3.6h3.6a1.8 1.8 0 1 1 0 3.6H8.4" />
    <path d="M12 6.6V17.4" />
  </>
);

export const IconCoreExpert = icon(
  <>
    <circle cx="11" cy="8.4" r="3.6" />
    <path d="M4.4 20.5a6.6 6.6 0 0 1 13.2 0" />
    <path d="M19.4 3.2 20.3 5.5 22.6 6.4 20.3 7.3 19.4 9.6 18.5 7.3 16.2 6.4 18.5 5.5Z" fill="currentColor" stroke="none" />
  </>
);

export const IconIntegrations = icon(
  <>
    <path d="M9.6 3.5v5.2" />
    <path d="M14.4 3.5v5.2" />
    <path d="M6.4 8.7h11.2v3.9a5.6 5.6 0 0 1-11.2 0z" />
    <path d="M12 18.2v2.8" />
  </>
);

export const IconBilling = icon(
  <>
    <rect x="2.8" y="5.5" width="18.4" height="13" rx="2.2" />
    <path d="M2.8 10h18.4" />
    <path d="M6.5 14.6h3.5" />
  </>
);

export const CORE_ICONS = {
  boardroom: IconBoardroom,
  "command-center": IconCommandCenter,
  ceo: IconCeo,
  cfo: IconCfo,
  cmo: IconCmo,
  cto: IconCto,
  "executive-briefing": IconExecutiveBriefing,
  "financial-trends": IconFinancialTrends,
  "financial-sync": IconFinancialSync,
  "statement-history": IconStatementHistory,
  "company-trajectory": IconCompanyTrajectory,
  forecasting: IconForecasting,
  "smart-alerts": IconSmartAlerts,
  "business-cockpit": IconBusinessCockpit,
  benchmarking: IconBenchmarking,
  "supplier-audit": IconSupplierAudit,
  "advanced-tools": IconAdvancedTools,
  "c-ore-connect": IconCoreConnect,
  "c-ore-fund": IconCoreFund,
  "c-ore-expert": IconCoreExpert,
  integrations: IconIntegrations,
  billing: IconBilling,
};

export default function CoreIcon({ name, size = 20, className, ...rest }) {
  const Glyph = CORE_ICONS[name];
  if (!Glyph) return null;
  return <Glyph size={size} className={className} {...rest} />;
}
